import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import PlayerDashboard from './components/PlayerDashboard';
import Welcome from './components/Welcome';
import TournamentDetail from './components/TournamentDetail';
import TurnosSignUp from './components/TurnosSignUp';
import Success from './components/Success';
import CheckoutClover from './components/CheckoutClover';
import MyRegisteredTournaments from './components/MyRegisteredTournaments';
import CutResultsPage from './components/CutResultsPage';
import AllTournamentResults from './components/AllTournamentResults';
import PlayerFinances from './components/PlayerFinances';
import ResetPassword from './components/ResetPassword';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import AdminTournamentEntries from './components/AdminTournamentEntries';
import RecruiterRoster from './components/RecruiterRoster';
import AdminRecruiterRosterPage from './components/AdminRecruiterRosterPage';
import AdminMoveSquads from './components/AdminMoveSquads';
import AdminEntryPOS from './components/AdminEntryPOS';
import MakeTeams from './components/MakeTeams';
import AdminManageTeams from './components/AdminManageTeams';
import AdminBowlerHistory from './components/AdminBowlerHistory';
import TournamentLists from './components/TournamentLists';
import WebFees from './components/WebFees';
import AdminReports from './components/AdminReports';

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/dashboard" element={<PlayerDashboard />} />
                <Route path="/welcome" element={<Welcome />} />
                <Route path="/tournament" element={<TournamentDetail />} />
                <Route path="/turnos-signup" element={<TurnosSignUp />} />
                <Route path="/success" element={<Success />} />
                <Route path="/checkout" element={<CheckoutClover />} />
                <Route path="/my-tournaments" element={<MyRegisteredTournaments />} />
                <Route path="/cut-results" element={<CutResultsPage />} />
                <Route path="/all-tournament-results" element={<AllTournamentResults />} />
                <Route path="/my-finances" element={<PlayerFinances />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/admin/tournament-entries" element={<AdminTournamentEntries />} />
                <Route path="/recruiter/roster" element={<RecruiterRoster />} />
                <Route path="/admin/recruiter-roster/:recruiterClave/:torneoClave" element={<AdminRecruiterRosterPage />} />
                <Route path="/admin/move-squads" element={<AdminMoveSquads />} />
                <Route path="/admin/entry-pos/:torneoClave/:jugadorClave" element={<AdminEntryPOS />} />
                <Route path="/admin/manage-teams" element={<AdminManageTeams />} />
                <Route path="/admin/bowler-history" element={<AdminBowlerHistory />} />
                <Route path="/admin/tournament-lists" element={<TournamentLists />} />
                <Route path="/admin/web-fees" element={<WebFees />} />
                <Route path="/admin/reports/:torneoClave" element={<AdminReports />} />
                <Route path="/make-teams" element={<MakeTeams />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;